import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.string.starts-with";
import "core-js/modules/es.string.fixed";
import "regenerator-runtime/runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from 'vue';
import { VSelect, VTextField, VMenu } from 'vuetify/lib';
import ErrorTooltip from '@comp/forms/ErrorTooltip.vue';
import Popper from '@comp/base/Popper.vue';
import Icon from '@comp/Icon.vue';
import TextInput from '@comp/forms/inputs/TextInput.vue';
import ArrowIcon from '!!url-loader?!@static/icons/s-arrow.svg';
import SearchIcon from '!!url-loader?!@static/icons/s-search.svg';
import CheckIcon from '!!url-loader?!@static/icons/s-check.svg';
export default {
  name: 'SelectInput',
  components: {
    ErrorTooltip: ErrorTooltip,
    CustomVSelect: extendVSelect(),
    Icon: Icon,
    TextInput: TextInput
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    name: String,
    value: {},
    placeholder: String,
    error: String,
    arrowIcon: {
      type: String,
      default: ArrowIcon
    },
    disabled: Boolean,
    clearable: Boolean,
    searchable: Boolean,
    activeIcon: Boolean,
    selectionIcon: Boolean,
    selectedTitleKey: String,
    fixed: Boolean,
    minWidth: Number,
    noWrap: Boolean,
    zIndex: Number
  },
  data: function data() {
    return {
      ArrowIcon: ArrowIcon,
      SearchIcon: SearchIcon,
      CheckIcon: CheckIcon,
      showList: false,
      menuOptions: {
        bottom: true,
        offsetY: true,
        contentClass: this.searchable ? 'v-select-menu searchable' : this.noWrap ? 'v-select-menu no-wrap' : 'v-select-menu'
      },
      searchInput: ''
    };
  },
  computed: {
    activeListItem: function activeListItem() {
      var _this = this;

      try {
        return this.list.find(function (z) {
          return z.value === _this.value;
        });
      } catch (err) {
        return null;
      }
    }
  },
  methods: {
    handleChange: function handleChange(v) {
      this.searchInput = '';
      this.$emit('input', v);
    },
    handleSearchUpdate: function handleSearchUpdate(v) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this2.searchable) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _this2.searchInput = v;

                _this2.$refs.select.activateMenu();

                _this2.$nextTick(function () {
                  var input = _this2.$refs.searchInput.$el.querySelector('input');

                  if (input) setTimeout(function () {
                    return input.focus();
                  }, 100);
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    highlightItem: function highlightItem(_ref) {
      var list = _ref.parent,
          item = _ref.item;
      return list.genFilteredText(list.getText(item));
    }
  }
};
var CustomMenu = VMenu.extend({
  props: {
    fixed: Boolean,
    minWidth: Number
  },
  computed: {
    styles: function styles() {
      return {
        position: 'static',
        maxHeight: '350px',
        minWidth: this.minWidth ? "".concat(this.minWidth, "px") : this.activator ? "".concat(this.activator.offsetWidth + 4, "px") : 0
      };
    }
  },
  methods: {
    initDetach: function initDetach() {//ignored
    },
    updateDimensions: function updateDimensions() {//ignored
    }
  },
  beforeDestroy: function beforeDestroy() {//ignored
  },
  render: function render(h) {
    var _this3 = this;

    var scopeId = Object.keys(this.getContentSlot()[0].data.attrs).find(function (x) {
      return x.startsWith('data-v-');
    });
    var data = {
      class: 'select-input-popper',
      attrs: scopeId ? _defineProperty({}, scopeId, '') : undefined,
      props: {
        placement: 'bottom',
        arrow: false,
        offset: 0,
        flipOnOverflow: true,
        show: this.isContentActive,
        reference: function reference() {
          return _this3.$parent.$el;
        },
        fixed: this.fixed,
        zIndex: 9
      }
    };
    return h(Popper, data, [this.genTransition()]);
  }
});

function extendVSelect() {
  return VSelect.extend({
    props: {
      scopeId: String,
      searchable: Boolean,
      searchInput: String,
      attach: {
        default: undefined
      },
      fixed: Boolean,
      minWidth: Number
    },
    computed: {
      computedItems: function computedItems() {
        var _this4 = this;

        if (!this.searchable || !this.searchInput) return this.allItems;
        return this.allItems.filter(function (item) {
          return _this4.getText(item).toLocaleLowerCase().indexOf(_this4.searchInput.toLocaleLowerCase()) !== -1;
        });
      },
      listData: function listData() {
        var data = VSelect.options.computed.listData.call(this);
        data.props = _objectSpread(_objectSpread({}, data.props), {}, {
          items: this.virtualizedItems,
          noFilter: !this.searchable,
          searchInput: this.searchInput
        });
        data.ref = 'list';
        return data;
      }
    },
    methods: {
      onKeyPress: function onKeyPress(e) {
        if (this.searchable) this.$emit('update:searchInput', e.key);else VSelect.options.methods.onKeyPress.call(this, e);
      },
      genMenu: function genMenu() {
        var _this5 = this;

        var props = _objectSpread(_objectSpread({}, this.$_menuProps), {}, {
          fixed: this.fixed,
          minWidth: this.minWidth
        });

        props.activator = this.$refs['input-slot'];
        return this.$createElement(CustomMenu, {
          attrs: {
            role: undefined
          },
          props: props,
          on: {
            input: function input(val) {
              _this5.isMenuActive = val;
              _this5.isFocused = val;
            }
          },
          ref: 'menu'
        }, [this.genList()]);
      }
    }
  });
}